import gql from 'graphql-tag';

export const UPDATE_LOOK_ORGANIZATION_FILTER = gql`
  mutation updateLookOrganizationFilter($filter: OrganizationFilterInput!, $orderBy: [String]) {
    updateLookOrganizationFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
